import React from "react";

const WrongRoute = () => {
  return (
    <div className="d-flex justify-content-center align-items-center mt-5">
      <div>
        <h1 className="text-danger fs-1">Oppsss...</h1>
        <h4 className="text-primary">Error !! Something is Wrong</h4>
      </div>
    </div>
  );
};

export default WrongRoute;
